<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Plant for the Planet Matching Grant Program</span>
</mat-toolbar> -->
<div class="mobile-action-bar">
    <div class="action-mobile-button warn-button"
        (click)="onCancel()">Cancel</div>
    <div class="action-mobile-button secondary-button"
        *ngIf="isShowSaveAsDraft"
        (click)="onSaveAsDraft()">Save</div>
    <div class="action-mobile-button primary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSubmit()">Submit</div>
    <div class="action-mobile-button secondary-button"
        *ngIf="isReadOnly && !isShowSaveAsDraft &&
        isShowSubmitBtn"
        (click)="onSubmit()">Save
        Change(s)</div>
    <div class="action-mobile-button warn-button" *ngIf="isShowApproveBtn"
        (click)="onReject()">Reject</div>
    <div class="action-mobile-button primary-button" *ngIf="isShowApproveBtn"
        (click)="onApprove()">Approve</div>
    <!-- <button class="action-mobile-button" fxFlex *ngIf="isShowReassignBtn"
            (click)="onWithdrawReject('Reassigned')" color="primary">Reassign To CIT</button> -->
    <div class="action-mobile-button warn-secondary-button"
        *ngIf="isShowWithDrawBtn"
        (click)="onWithdrawn()">Withdraw</div>
</div>

<mat-toolbar
    *ngIf="isFormExpired && !hasRole('ADMIN') && !hasRole('PFTPAPPROVER') &&
    (ppForm.value.statusId === 2 || ppForm.value.statusId === null)"
    color="primary" style="background-color: red">
    <span>Plant for the Planet Matching Grant Program application has been
        expired!</span>
</mat-toolbar>
<div class="info-container">
    <mat-card-subtitle class="leading-9">
        <p>
            Eligible grantees include projects that will improve the
            environment and the lives of individuals
            who live, work or play near the planting area. We offer
            one-year matching grants of $500 to $5000
            for urban, suburban or rural projects in forests and parks,
            along parkways or roadways that meet program objectives.
            Applicants must demonstrate that mature
            trees resulting from their efforts will not interfere with
            utility lines. Please enter the same EIN
            and organization name that appeared
            on your 501(c)(3) verification screen.
        </p>
        <p>
            FOR MORE INFORMATION SEE POLICY:
            <a
                href="https://lge-ku.com/sites/default/files/CharitableContributionsExternalUser.pdf"
                target="_blank">General Instructions</a>
        </p>
        <p>
            <b>*</b> = Mandatory
        </p>
    </mat-card-subtitle>
</div>
<div autoscroll="true" class="content"
    [@routeAnimation]="true">

    <!-- <mat-card>
        <mat-card-title>Total Plant for the Planet Grant Requestty Investment (External Only)</mat-card-title>
    </mat-card> -->
    <form class="form-content" [formGroup]="ppForm"
        enctype="multipart/form-data">
        <!-- <mat-card> -->
        <!-- <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center"
            fixed [fxShow.xs]="true" [fxShow.sm]="true"
            [fxShow]="false">
            <button mat-fab (click)="onCancel()" color="warn">Cancel</button>
            <button mat-fab *ngIf="isShowApproveBtn" (click)="onReject()"
                color="warn">Reject</button>
            <button mat-fab *ngIf="isShowApproveBtn" [disabled]='ppForm.invalid
                || !isValid || !isFilled'
                (click)="onApprove()" color="primary">Approve</button>
        </div> -->
        <!-- <mat-card fxLayout="column">
            <mat-form-field>
                <input type="text" matInput placeholder="Request Name *" maxlength="100" formControlName="FormPPName"
                    [readonly]='!isReadOnly'>
            </mat-form-field>
        </mat-card> -->
        <mat-card formGroupName="OrgInfoFormPP">
            <mat-card-subtitle><b>Organization Information</b></mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <input readonly type="text" formControlName="name" matInput
                    placeholder="Organization Name"
                    maxlength="80" [attr.disabled]='!isReadOnly'>
                <mat-hint *ngIf="isMaxLength" style="color:red">The organization
                    name has exceeded the max length
                    allowed by current system. Please provide a new name in the
                    "Payable To" field.</mat-hint>
            </mat-form-field>
            <mat-card-content>
                <mat-card-subtitle>Is "Payable To" name different than the
                    Organization Name? *</mat-card-subtitle>
                <mat-radio-group formControlName="payToOption"
                    [disabled]='!isReadOnly || isMaxLength'>
                    <mat-radio-button color="primary" value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary" value="No">No</mat-radio-button>
                </mat-radio-group>

            </mat-card-content>
            <mat-form-field fxLayout="column" *ngIf="payToOption">
                <input [readonly]="!isReadOnly" type="text"
                    formControlName="payTo" matInput placeholder="Payable To"
                    maxlength="80" [readonly]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field fxLayout="column">
                <input type="text" readonly formControlName="EIN" matInput
                    placeholder="EIN">
            </mat-form-field>
            <mat-form-field fxLayout="column">
                <input type="text" formControlName="address1" matInput
                    placeholder="Address1" maxlength="35"
                    [attr.disabled]='!isReadOnly'>
                <!-- <mat-hint align="end">Characters {{ ppForm.controls.OrgInfoFormCI.controls.address1.value.length}} / 35</mat-hint> -->
            </mat-form-field>
            <mat-form-field fxLayout="column">
                <input type="text" formControlName="address2" matInput
                    placeholder="Address2" maxlength="35"
                    [attr.disabled]='!isReadOnly'>
                <!-- <mat-hint align="end">Characters {{ ppForm.controls.OrgInfoFormCI.controls.address2.value.length}} / 35</mat-hint> -->
            </mat-form-field>
            <mat-form-field fxLayout="column">
                <input type="text" formControlName="city" matInput
                    placeholder="City" maxlength="25"
                    [attr.disabled]='!isReadOnly'>
                <!-- <mat-hint align="end">Characters {{ ppForm.controls.OrgInfoFormCI.controls.city.value.length}} / 50</mat-hint> -->
            </mat-form-field>
            <mat-form-field fxLayout="column">
                <input type="text" formControlName="county" matInput
                    placeholder="County" maxlength="35"
                    [attr.disabled]='!isReadOnly'>
                <!-- <mat-hint align="end">Characters {{ ppForm.controls.OrgInfoFormCI.controls.city.value.length}} / 50</mat-hint> -->
            </mat-form-field>
            <mat-form-field fxLayout="column">
                <!-- <input type="text" formControlName="state" matInput placeholder="State" [attr.disabled]='!isReadOnly'> -->
                <mat-select placeholder="State" formControlName="state"
                    [disabled]='!isReadOnly'>
                    <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field fxLayout="column">
                <input type="text" formControlName="zipCode" zipCode matInput
                    placeholder="Zip Code*" maxlength="10"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field *ngIf='!hasRole(" DEV" )'>
                <input type="text" matInput placeholder="Tax-Exempt Status"
                    maxlength="15"
                    [value]="getTaxExemptStatus(ppForm.get(['OrgInfoFormPP','subsection_501']).value)"
                    readonly>
            </mat-form-field>
            <mat-form-field *ngIf='hasRole(" DEV" )'>
                <mat-select placeholder="Tax Exempt Status"
                    formControlName="subsection_501">
                    <mat-option *ngFor="let subsection of taxExemptList"
                        [value]="subsection">
                        {{getTaxExemptStatus(subsection)}}</mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card>

        <mat-card formGroupName="OrgContactInfoFormPP" fxLayout="column">
            <mat-card-subtitle><b>Organization Contact Information</b></mat-card-subtitle>
            <mat-card-subtitle><b><i>The primary contact information should be
                        the person who will manage the grant. All
                        important communication will be directed to that
                        individual.</i></b></mat-card-subtitle>
            <!-- <mat-form-field>
                <mat-select placeholder="Title*" formControlName="title" [disabled]='!isReadOnly'>
                    <mat-option *ngFor="let title of titles" [value]="title">{{title}}</mat-option>
                </mat-select>
            </mat-form-field> -->
            <mat-form-field>
                <input type="text" matInput placeholder="First Name"
                    maxlength="150" formControlName="firstName"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput placeholder="Last Name"
                    maxlength="150" formControlName="lastName"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" phone formControlName="phone" maxlength="12"
                    matInput placeholder="Phone Number"
                    [attr.disabled]='!isReadOnly'>
                <mat-hint>Example: xxx-xxx-xxxx</mat-hint>
            </mat-form-field>
            <mat-form-field>
                <input type="email" matInput placeholder="Email Address"
                    maxlength="254" formControlName="email"
                    [attr.disabled]='!isReadOnly'>
                <mat-hint>Example: you@example.com</mat-hint>
                <!-- <mat-hint align="end">Characters {{ ppForm.controls.OrgContactInfoFormCI.controls.email.value.length}} / 254</mat-hint> -->
            </mat-form-field>
        </mat-card>
        <mat-card fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>Project Name *</mat-card-subtitle>
            <mat-form-field>
                <input type="text" matInput maxlength="30"
                    formControlName="projectName" [readonly]='!isReadOnly'>
                <mat-hint align="end">({{
                    ppForm.get('projectName').value.length}}/30
                    Characters limit)</mat-hint>
            </mat-form-field>

            <mat-card-subtitle>Planting will occur in (choose service area)*:</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <mat-select [disabled]='!isReadOnly' placeholder="Service
                    Area(s)" formControlName="serviceArea"
                    multiple [disabled]='!isReadOnly'>
                    <mat-option *ngFor="let serviceArea of serviceAreas"
                        [value]="serviceArea">{{serviceArea}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-card-subtitle>Your organization is required to promote our
                Right Tree, Right Place program. Please
                describe your promotion efforts. *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='1500'
                        [attr.disabled]='!isReadOnly'
                        formControlName="promotionEffort"
                        matInput matTextareaAutosize matAutosizeMinRows="3"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500 </mat-hint>
                </mat-form-field>
            </mat-card-content>

            <mat-card-subtitle>Please describe your organization’s ongoing tree
                planting efforts. *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='1500'
                        [attr.readonly]='!isReadOnly'
                        formControlName="plantingEffort"
                        matInput matTextareaAutosize matAutosizeMinRows="3"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500</mat-hint>
                </mat-form-field>
            </mat-card-content>
        </mat-card>
        <mat-card fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle><b>Project Detail Highlights</b></mat-card-subtitle>
            <mat-card-subtitle>Number of trees to be planted: *</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <input [readonly]='!isReadOnly' type="text" [textMask]='{mask:
                    noDecMask}'
                    formControlName="numTreePlanted" maxlength="5" matInput>
            </mat-form-field>
            <mat-card-subtitle>Estimated size of trees at planting (ex:
                "seedling" or "2-inch caliper"): *
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field fxLayout="column">
                    <input [readonly]='!isReadOnly' type="text"
                        formControlName="treeSize" maxlength="50" matInput>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>Type of Trees (please check all that apply): *</mat-card-subtitle>
            <mat-card-subtitle>Invasive trees are not funded through the PFTP
                Grant.</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <mat-select placeholder="Type of Trees"
                    formControlName="treeType" multiple
                    [disabled]='!isReadOnly'>
                    <mat-option *ngFor="let treeType of treeTypes"
                        [value]="treeType">{{treeType}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div fxLayout="column" fxLayoutGap="20px" fxLayout.sm="column"
                fxLayout.xs="column">
                <mat-card-subtitle fxLayout="row">Anticipated Planting Date *:</mat-card-subtitle>
                <mat-form-field fxLayout="row">
                    <input matInput [min]="minEffdt" [matDatepicker]="picker1"
                        readonly placeholder=""
                        formControlName="plantDate" [disabled]='!isReadOnly'>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                    <mat-hint align="end">choose from dropdown ^</mat-hint>
                </mat-form-field>
            </div>
            <mat-card-subtitle><b>Project Narrative. *</b></mat-card-subtitle>
            <mat-card-subtitle>*Describe how your project meets the Plant for
                the Planet grant objectives, including
                the scope, justification and any educational components.
            </mat-card-subtitle>
            <mat-form-field>
                <textarea CharLimit [MaxChar]='1500'
                    [attr.disabled]='!isReadOnly'
                    formControlName="projNarrative"
                    matInput matTextareaAutosize matAutosizeMinRows="3"
                    matAutosizeMaxRows="10"></textarea>
                <mat-hint align="end">Characters count (not includes spaces) 0 /
                    1500</mat-hint>
            </mat-form-field>
            <mat-card-subtitle><b>Project Partner. *</b></mat-card-subtitle>
            <mat-card-subtitle>*List your participating partners, volunteers,
                and involved school groups.
            </mat-card-subtitle>
            <mat-form-field>
                <textarea CharLimit [MaxChar]='500'
                    [attr.disabled]='!isReadOnly' formControlName="projPartner"
                    matInput
                    matTextareaAutosize matAutosizeMinRows="3"
                    matAutosizeMaxRows="10"></textarea>
                <mat-hint align="end">Characters count (not includes spaces) 0 /
                    500</mat-hint>
            </mat-form-field>
            <mat-card-subtitle>
                <b>Previous Tree-planting Efforts (PDF only) *</b>
            </mat-card-subtitle>
            <mat-card-subtitle>
                <i>Attach a narrative describing your successful tree-planting
                    projects, includings those previously
                    funded by LG&E/KU/ODP.</i>
            </mat-card-subtitle>
            <mat-card-content fxLayoutGap="10px">
                <!-- <input type="file" accept="application/pdf" #fileInput multiple formControlName="addAttach" [attr.disabled]='!isReadOnly'> -->
                <input *ngIf='isReadOnly' type="file" accept="application/pdf"
                    (change)="onAttachFileChange($event,'previousEffortAttach')"
                    #fileInput3>
                <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                    <a class="list-item" mat-list-item
                        *ngFor="let file of
                        ppForm.get('previousEffortAttach')['controls']">
                        <mat-icon class="icon-cursor" mat-list-icon
                            color="primary"
                            *ngIf="ppForm.get('previousEffortAttach')['controls'].length
                            != 0"
                            (click)="DownloadAttachFile('previousEffortAttach',
                            file.value.attachName)">
                            save_alt</mat-icon>
                        <mat-icon class="icon-cursor" mat-list-icon
                            color="warn"
                            *ngIf="ppForm.get('previousEffortAttach')['controls'].length
                            != 0 && isReadOnly"
                            (click)="resetFileInput('previousEffortAttach')">
                            delete_forever</mat-icon>
                        <h4 mat-line style="cursor: default;">
                            {{ file.value.attachName }}
                        </h4>
                    </a>
                </mat-nav-list>
                <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                    *ngIf="ppForm.get('previousEffortAttach')['controls'].length != 0 && (!isReadOnly || this.hasRole('ADMIN'))">
                    <a class="list-item" mat-list-item
                        *ngFor="let file of ppForm.get('previousEffortAttach')['controls']">
                        <mat-icon class="icon-cursor" mat-list-icon
                            (click)="DownloadAttachFile('previousEffortAttach', file.value.attachName)">
                            save_alt</mat-icon>
                        <h4 mat-line style="cursor: default;">
                            {{ file.value.attachName }}
                        </h4>
                    </a>
                </mat-nav-list> -->
            </mat-card-content>
            <mat-card-subtitle>
                <b>Attach schematic with proposed planting locations, existing
                    structures and utilities (PDF only)
                    *</b>
            </mat-card-subtitle>
            <mat-card-content fxLayoutGap="10px">
                <!-- <input type="file" accept="application/pdf" #fileInput multiple formControlName="addAttach" [attr.disabled]='!isReadOnly'> -->
                <input *ngIf='isReadOnly' type="file" accept="application/pdf"
                    (change)="onAttachFileChange($event,'schematicAttach')"
                    #fileInput4>
                <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                    <a class="list-item" mat-list-item *ngFor="let file of
                        ppForm.get('schematicAttach')['controls']">
                        <mat-icon class="icon-cursor" mat-list-icon
                            color="primary"
                            *ngIf="ppForm.get('schematicAttach')['controls'].length
                            != 0"
                            (click)="DownloadAttachFile('schematicAttach',
                            file.value.attachName)">
                            save_alt</mat-icon>
                        <mat-icon class="icon-cursor" mat-list-icon
                            color="warn"
                            *ngIf="ppForm.get('schematicAttach')['controls'].length
                            != 0
                            && isReadOnly"
                            (click)="resetFileInput('schematicAttach')">
                            delete_forever</mat-icon>
                        <h4 mat-line style="cursor: default;">
                            {{ file.value.attachName }}
                        </h4>
                    </a>
                </mat-nav-list>
                <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                    *ngIf="ppForm.get('schematicAttach')['controls'].length != 0
                    && (!isReadOnly || this.hasRole('ADMIN'))">
                    <a class="list-item" mat-list-item *ngFor="let file of
                        ppForm.get('schematicAttach')['controls']">
                        <mat-icon class="icon-cursor" mat-list-icon
                            (click)="DownloadAttachFile('schematicAttach',
                            file.value.attachName)">
                            save_alt</mat-icon>
                        <h4 mat-line style="cursor: default;">
                            {{ file.value.attachName }}
                        </h4>
                    </a>
                </mat-nav-list> -->
                <!-- <mat-card *ngIf="!isInternal">
                        <mat-card-subtitle style="line-height: 25px;color:red">
                            Please submit your application without uploading your attachments. When you receive your submission email, please reply to that email with your attachments.
                        </mat-card-subtitle>
                    </mat-card> -->
            </mat-card-content>
            <!-- 
                <mat-card *ngIf="!isInternal">
                    <mat-card-subtitle style="line-height: 25px;color:red">
                        Please submit your application without uploading your attachments. When you receive your submission email, please reply to that email with your attachments.
                    </mat-card-subtitle>
                </mat-card> -->
            <mat-card-subtitle>
                <b>Tree Project Budget Narrative*</b>
            </mat-card-subtitle>
            <mat-card-subtitle>
                <i>*Provide a short narrative explaining the detailed project
                    budget,
                    including cost and match dollars. Eighty percent (80%) of
                    PFTP funds must be used for purchasing plant materials;
                    plant materials shall include trees, shrubs, ground covers,
                    and vines. Twenty percent (20%) or less of the PFTP funds
                    may be used for labor and equipment. All PFTP grant funds
                    must be matched dollar-for-dollar from other funding
                    sources.
                    The match can either be cash, in-kind services or a
                    combination of both</i>
            </mat-card-subtitle>

            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='1500'
                        [attr.disabled]='!isReadOnly'
                        formControlName="budgetNarr"
                        matInput matTextareaAutosize matAutosizeMinRows="3"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500 </mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>
                <b>Maintenance Schedule Narrative. *</b>
            </mat-card-subtitle>
            <mat-card-subtitle>
                <i>*All successful grant awardees must adhere to strict
                    maintenance requirements.
                    Please describe how your organization will maintain the
                    newly planted trees
                    to prevent them from being destroyed by mowers, deer,
                    drought and other natural
                    or non-natural challenges. Please include a maintenance plan
                    describing the
                    proper watering schedule and the planned pruning, mulching
                    and stake removal.</i>
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='1500'
                        [attr.disabled]='!isReadOnly'
                        formControlName="maintenanceSchedNarr" matInput
                        matTextareaAutosize matAutosizeMinRows="3"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500 </mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>Provide the name of the person(s) who will be
                responsible for overseeing the
                maintenance practices described for a minimum of three (3) years
                from the date of tree planting. *:
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field fxLayout="column">
                    <input [readonly]='!isReadOnly' type="text"
                        formControlName="overseePerson" maxlength="50" matInput>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>Do you have the ability to keep trees watered
                following planting? *
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="hasTreeWatered"
                    [disabled]='!isReadOnly'>
                    <mat-radio-button color="primary" value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary" value="No">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
            <mat-card-subtitle>Do you plan to use gator bags for watering? *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="useGatorBags"
                    [disabled]='!isReadOnly'>
                    <mat-radio-button color="primary" value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary" value="No">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
            <mat-card-subtitle [ngClass]="{'red-warning':
                ppForm.get('numBagsUse').invalid}" *ngIf="useGatorBag">
                If yes, how many bags do you require? *.</mat-card-subtitle>
            <mat-card-content *ngIf="useGatorBag" fxLayout="column">
                <mat-form-field>
                    <input [readonly]='!isReadOnly' formControlName="numBagsUse"
                        [textMask]='{mask: noDecMask}'
                        maxlength="5" type="text" matInput>
                    <!-- <mat-hint align="end">Characters {{ ciForm.controls.taxExemptStatus.value.length}} / 25</mat-hint> -->
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>Total Plant for the Planet Grant Request: *</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <mat-hint style='color: black'>We match at a minimum of $500 and
                    a maximum of $5000</mat-hint>
                <input [readonly]='!isReadOnly' DecimalTrail [MinVal]=500
                    [MaxVal]=5000 maxlength="10"
                    [textMask]="{mask: twoDecMask}"
                    formControlName="amountRequest" matInput type="text">
                <span matPrefix>$&nbsp;</span>
            </mat-form-field>
            <mat-card-subtitle>Total Tree Project Cost: *</mat-card-subtitle>
            <mat-form-field>
                <input [readonly]='!isReadOnly' DecimalTrail maxlength="10"
                    formControlName="projectCost" matInput
                    type="text">
                <span matPrefix>$&nbsp;</span>
            </mat-form-field>
            <mat-card-subtitle>If you are a successful awardee, would you prefer
                that the grant payment be made by
                credit card? *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="payment"
                    [disabled]='!isReadOnly'>
                    <mat-radio-button color="primary" value="CREDIT">Yes</mat-radio-button>
                    <mat-radio-button color="primary" value="CHECK">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
        </mat-card>

        <mat-card fxLayout="column" formGroupName="AuthorizedRep"
            fxLayoutGap="15px">
            <div class="info-container">
                <h4 style="color:red"><b>Authorization</b></h4>
                <mat-card-subtitle class="leading-9">
                    <p>
                        The signature of your organization’s authorized
                        representative below obligates your organization
                        to spend any and all funds awarded as a result of this
                        application only for the purpose(s)
                        described within this application. Awarded funds spent
                        for any other purpose will be forfeited,
                        and your organization will be obligated to return any
                        such funds immediately. LG&E, KU/ODP and
                        the Foundation (“Granting Entities”) reserve the right
                        to revoke any award and demand the return
                        of all funds spent for any purpose other than that
                        described in this application or for any
                        other material misrepresentation.
                    </p>
                    <p>
                        A request for applications made by the Granting Entities
                        does not constitute an offer or a
                        commitment to award funds. Your organization should not
                        act in reliance on an assumption that
                        funds will be awarded.
                    </p>
                    <p>
                        This application portal and its content are provided on
                        an “as is” basis. The Granting Entities
                        make no representations or warranties, either express or
                        implied, regarding this application
                        portal or its
                        content, and hereby specifically disclaim any and all
                        such representations or warranties of any
                        kind, including any with respect to the completeness,
                        accuracy, or currency of the content or
                        its suitability for any particular purpose.
                    </p>

                    <p>
                        The Granting Entities do not guarantee continuous,
                        uninterrupted, or secure access to this
                        application portal. Your organization is responsible for
                        the costs it incurs in preparing and
                        submitting any application using the application portal.
                        Use of this application portal is
                        solely at each user’s own risk.
                    </p>
                    <p>
                        The Granting Entities may suspend or terminate any
                        user’s access to this application portal at
                        any time for any reason. The Granting Entities reserve
                        the right at any time, with or without
                        notice or reasons, to discontinue any application
                        process. The Granting Entities, in their sole
                        and exclusive discretion, and with or without notice or
                        reason, may (i) accept or reject any
                        application in whole or in part, (ii) reject all
                        applications, or (iii) withdraw any request for
                        applications at any time before or after submission of
                        applications. The Granting Entities
                        retain the discretion and right to change the criteria
                        for evaluating applications even after a
                        request for applications has been released and/or
                        responses to a request for applications have
                        been received.
                    </p>
                    <p>
                        By submitting an application, your organization
                        represents that it has sufficient intellectual
                        property rights to submit the content of the
                        application. The Granting Entities reserve the
                        right to retain copies of application materials
                        indefinitely. Use of any materials containing or
                        using the Granting Entities’ names, logos or trademarks
                        shall be subject to their prior review
                        and approval. Conditioned upon such approval in Granting
                        Entities’ case, the parties hereby
                        grant each other a free, non-exclusive, limited and
                        revocable license to use their intellectual
                        property solely in accordance with the terms, conditions
                        and intended uses hereof. All other
                        rights are reserved and retained by their respective
                        owner.
                    </p>
                </mat-card-subtitle>
            </div>
            <mat-card-subtitle style="color:red"><b>Verified and submitted by
                    authorized representative *:</b>
            </mat-card-subtitle>
            <mat-card-content>
                <!-- <mat-form-field fxLayout="column">
                    <mat-select [disabled]='!isReadOnly' placeholder="Title *" formControlName="title"
                        placeholder="Title">
                        <mat-option *ngFor="let title of titles" [value]="title">{{title}}</mat-option>
                    </mat-select>
                </mat-form-field> -->
                <mat-form-field fxLayout="column">
                    <input [readonly]='!isReadOnly' type="text"
                        formControlName="name" maxlength="25" matInput
                        placeholder="Name">
                    <!-- <mat-hint align="end">Characters {{ ppForm.controls.AuthorizedRep.controls.name.value.length}} / 25</mat-hint> -->
                </mat-form-field>
                <mat-form-field>
                    <input [readonly]='true' formControlName="date" readonly
                        matInput
                        placeholder="Date Drafted/Submitted">
                    <!-- <mat-datepicker-toggle readonly matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker readonly #picker1></mat-datepicker> -->
                </mat-form-field>
            </mat-card-content>
            <mat-card-content>
                <mat-hint fxLayout="column" class="red-warning">*Application
                    will not be considered unless signed by
                    an authorized representative.</mat-hint>
            </mat-card-content>
            <mat-card-subtitle><b>Authorized Signature: </b></mat-card-subtitle>
            <mat-card-subtitle>(Please use your mouse to sign in the space
                below)</mat-card-subtitle>
            <mat-card-content fxLayout="row" [fxShow.xs]="false"
                [fxShow.sm]="false">
                <signature-pad style="border-style: solid; border: #009E49"
                    matInput [options]="signaturePadOptions"
                    (onEndEvent)="drawComplete()" #signaturePad></signature-pad>
            </mat-card-content>
            <mat-card-content fxLayout="row" [fxShow.xs]="false"
                [fxShow.sm]="false">
                <button *ngIf="isReadOnly && isShowSaveAsDraft"
                    mat-raised-button (click)="drawClear()"
                    color="warn">Clear Signature</button>
            </mat-card-content>
            <mat-card fxShow="false" [fxShow.xs]="true" [fxShow.sm]="true">
                <mat-card-subtitle class="red-warning">
                    The signature pad is not supported with you device's
                    resolution.
                </mat-card-subtitle>
            </mat-card>
        </mat-card>

        <mat-card fxLayout="column" fxLayoutGap="16px" [fxShow.xs]="false"
            [fxShow.sm]="false">
            <mat-card-subtitle>
                <b>Attachments</b>
            </mat-card-subtitle>
            <mat-card>
                <mat-card-subtitle>Please upload a completed form W-9 for this
                    request.
                    <b>(PDF Only)*</b>
                </mat-card-subtitle>
                <mat-card-subtitle>Please Note: the provided W-9 must be the
                    version
                    <a href="https://lge-ku.com/sites/default/files/W9.pdf"
                        target="_blank">here.</a>
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <!-- <input type="file" accept="application/pdf" #fileInput formControlName="w9Form" [attr.disabled]='!isReadOnly'> -->
                    <input *ngIf='isReadOnly' type="file"
                        accept="application/pdf"
                        (change)="onAttachFileChange($event,'W9Attach')"
                        #fileInput1>
                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item *ngFor="let file of
                            ppForm.get('W9Attach')['controls']">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="ppForm.get('W9Attach')['controls'].length
                                != 0"
                                (click)="DownloadAttachFile('W9Attach',
                                file.value.attachName)">save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                *ngIf="ppForm.get('W9Attach')['controls'].length
                                != 0 &&
                                isReadOnly"
                                (click)="resetFileInput('W9Attach')">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list>
                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="ppForm.get('W9Attach')['controls'].length != 0 &&
                        (!isReadOnly || this.hasRole('ADMIN'))">
                        <a class="list-item" mat-list-item *ngFor="let file of
                            ppForm.get('W9Attach')['controls']">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('W9Attach',
                                file.value.attachName)">save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-subtitle>Please upload any other information your
                    organization believes to be pertinent to
                    this request. </mat-card-subtitle>
                <mat-card-subtitle><b>(PDF Only)</b>
                </mat-card-subtitle>
                <mat-card-content>
                    <!-- <input type="file" accept="application/pdf" #fileInput multiple formControlName="addAttach" [attr.disabled]='!isReadOnly'> -->
                    <input *ngIf='isReadOnly' type="file"
                        accept="application/pdf"
                        (change)="onAddAttachFileChange($event)" #fileInput2
                        multiple>

                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item
                            *ngIf="ppForm.get('AddAttach')['controls'].length !=
                            0">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAllAttachFile()">save_alt
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Download all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngIf="ppForm.get('AddAttach')['controls'].length !=
                            0
                            && isReadOnly">
                            <mat-icon color="warn" class="icon-cursor"
                                mat-list-icon (click)="resetAddAttach()">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Remove all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            ppForm.get('AddAttach')['controls']; let i= index">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="ppForm.get('AddAttach')['controls'].length
                                !=
                                0"
                                (click)="DownloadAttachFile('AddAttach',file.value.attachName)">save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                *ngIf="ppForm.get('AddAttach')['controls'].length
                                != 0
                                && isReadOnly"
                                (click)="removeFile(file.value.attachName)">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">{{i+1}}. {{
                                file.value.attachName }}</h4>
                        </a>
                    </mat-nav-list>

                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="ppForm.get('AddAttach')['controls'].length != 0
                        && (!isReadOnly || this.hasRole('ADMIN'))">
                        <a class="list-item" mat-list-item
                            *ngIf="ppForm.get('AddAttach')['controls'].length !=
                            0">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAllAttachFile()">save_alt
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Download all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            ppForm.get('AddAttach')['controls']; let i= index">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('AddAttach',file.value.attachName)">save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">{{i+1}}. {{
                                file.value.attachName }}</h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
            </mat-card>
        </mat-card>



        <mat-card fxLayout="column" fxLayoutGap="16px"
            *ngIf="ppForm.value.statusId !== null && ppForm.value.statusId !==2
            && (hasRole('PFTPAPPROVER') || hasRole('ADMIN'))">
            <mat-card-subtitle><b>Accounting Distribution*</b></mat-card-subtitle>
            <!-- <mat-card>
                <mat-card-subtitle>
                    <b>Payment Method *</b>
                </mat-card-subtitle>
                <mat-radio-group formControlName="payment" [disabled]='!isReadOnly'>
                    <mat-radio-button color = "primary" value="CHECK">Check</mat-radio-button>
                    <mat-radio-button color = "primary" value="CREDIT">Credit Card</mat-radio-button>
                </mat-radio-group>
            </mat-card> -->
            <div class="account-dist-container">

                <table style="padding: 16px" formArrayName="AccDistribution">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Company</th>
                            <th>Project</th>
                            <th>Task</th>
                            <th>Exp-Type</th>
                            <th>Exp-Org</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [formGroupName]="i"
                            *ngFor="let accDist of
                            ppForm.get('AccDistribution')['controls']; let i=
                            index">
                            <td>{{ i+1 }}</td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="company"
                                        [disabled]='!isEditableAccDist '
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'company')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let company of
                                            accDistData[i].company"
                                            [value]="company.code">{{company.descr}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="project"
                                        [disabled]='!isEditableAccDist'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'project')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let project of
                                            accDistData[i].project"
                                            [value]="project.project">{{project.project}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="task"
                                        [disabled]='!isEditableAccDist'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'task')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let task of
                                            accDistData[i].task"
                                            [value]="task.task">
                                            {{task.task}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expType"
                                        [disabled]='!isEditableAccDist'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expType')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let expType of
                                            accDistData[i].expType"
                                            [value]="expType.code">{{expType.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expOrg"
                                        [disabled]='!isEditableAccDist'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expOrg')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let expOrg of
                                            accDistData[i].expOrg"
                                            [value]="expOrg.code">
                                            {{expOrg.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <input style="text-align: center;"
                                        DecimalTrail type="text"
                                        [textMask]="{mask: twoDecMask}" matInput
                                        (input)="calculateTotalAmount()"
                                        maxlength="11" formControlName="amount"
                                        [readonly]='!isEditableAccDist'>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>

                            <td colspan='5'></td>

                            <td style="text-align: left;">
                                <b>Total Amount:</b>
                            </td>
                            <td style="text-align: center;">
                                <span>
                                    <b>$ {{totalAmount}}</b>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column"
                fxLayoutAlign="end">
                <button mat-raised-button *ngIf="isEditableAccDist"
                    (click)="onSaveAccDist()"
                    color="primary">Save</button>
            </div>
        </mat-card>
        <mat-card fxLayout="column" fxLayoutGap="16px"
            *ngIf="ppForm.value.statusId !== null && ppForm.value.statusId !==2
            && (hasRole('ADMIN') || hasRole('PFTPAPPROVER') ||
            ppForm.value.statusDescr === 'Closed')">

            <mat-card>
                <mat-card-subtitle style="color:red"><b>Total awarded amount by
                        LG&E/KU/ODP *:</b></mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <mat-form-field>
                        <input readonly matInput type="text"
                            [value]="totalAmount">
                        <span matPrefix>$&nbsp;</span>
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
        </mat-card>
        <!-- <div fxLayout="row" [fxShow.xs]="false" [fxShow.sm]="false">
            <span>
                <mat-icon class="inline-icon" mat-list-icon>short_text</mat-icon>If unable to submit, complete all
                required
                fields.
            </span>
        </div> -->
        <!-- <mat-card fxLayout="row" fxLayout.xs="row" fxLayoutGap="20px"
            fxLayoutAlign="center center" [fxShow.xs]="false"
            [fxShow.sm]="false">

            <button mat-raised-button (click)="onCancel()" color="warn">Cancel</button>
            <button *ngIf="isReadOnly && isShowSaveAsDraft && isShowSubmitBtn"
                mat-raised-button
                (click)="onSaveAsDraft()" color="primary">Save
                As Draft</button>
            <button *ngIf="isReadOnly && isShowSaveAsDraft && isShowSubmitBtn"
                mat-raised-button (click)="onSubmit()"
                color="primary">Submit</button>
            <button *ngIf="isReadOnly && !isShowSaveAsDraft && isShowSubmitBtn"
                mat-raised-button (click)="onSubmit()"
                color="primary">Save Change(s)</button>
            <button mat-raised-button *ngIf="isShowApproveBtn"
                (click)="onReject()" color="warn">Reject</button>
            <button mat-raised-button *ngIf="isShowApproveBtn"
                (click)="onApprove()" color="primary">Approve</button>
            <button mat-raised-button *ngIf="isShowWithDrawBtn"
                (click)="onWithdrawn()" color="warn">Withdraw</button>
        </mat-card> -->
    </form>

</div> <br><br>
<div class="action-bar">
    <div matRipple class="action-button warn-button" (click)="onCancel()">Cancel</div>
    <div matRipple class="action-button secondary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSaveAsDraft()">Save
        As Draft</div>
    <div matRipple class="action-button primary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSubmit()">Submit</div>
    <div matRipple class="action-button secondary-button" *ngIf="isReadOnly &&
        !isShowSaveAsDraft && isShowSubmitBtn"
        (click)="onSubmit()">Save
        Change(s)</div>
    <div matRipple class="action-button warn-button" *ngIf="isShowApproveBtn"
        (click)="onReject()">Reject</div>
    <div matRipple class="action-button primary-button" *ngIf="isShowApproveBtn"
        (click)="onApprove()">Approve</div>
    <!-- <div matRipple class="action-button" *ngIf="isShowReassignBtn" (click)="onWithdrawReject('Reassigned')"
        color="primary">Reassign To CIT</div> -->
    <div matRipple class="action-button warn-secondary-button" *ngIf="isShowWithDrawBtn"
        (click)="onWithdrawn()">Withdraw</div>
</div>